import { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { showModal, hideModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

function Attendance() {
  const [notification, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [users, setUsers] = useState([]);
  const [tableUser, setTableUser] = useState([]);

  const [attendanceData, setAttendanceData] = useState([]);
  const [filterType, setFilterType] = useState("all");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // const [formData, setFormData] = useState({
  //   title: "",
  //   message: "",
  // });
  const [formData, setFormData] = useState({
    user_id: "",
    punch_in_pic_url: null,
    punch_out_pic_url: null,
    punch_in_latitude: "",
    punch_in_long: "",
    punch_out_latitude: "",
    punch_out_long: "",
    punch_in: "", // missing in your form structure
    punch_out: "",
  });

  const removeFormData = () => {
    setFormData({
      user_id: "",
    });
  };

  const axiosAPI = useAxios();

  const filterAttendance = (data, filterType) => {
    const now = new Date();

    return data.filter((record) => {
      const recordDate = new Date(record.date_and_time);

      if (filterType === "today") {
        return recordDate.toDateString() === now.toDateString();
      }

      if (filterType === "weekly") {
        const currentWeekStart = new Date(now);
        currentWeekStart.setDate(now.getDate() - now.getDay()); // Sunday

        const currentWeekEnd = new Date(currentWeekStart);
        currentWeekEnd.setDate(currentWeekEnd.getDate() + 6); // Saturday

        return recordDate >= currentWeekStart && recordDate <= currentWeekEnd;
      }

      if (filterType === "monthly") {
        return (
          recordDate.getMonth() === now.getMonth() &&
          recordDate.getFullYear() === now.getFullYear()
        );
      }

      return true; // If no filter, return all
    });
  };

  const filteredData = filterAttendance(attendanceData, filterType);
  // console.log("filter ", filteredData);

  const getUsers = async () => {
    try {
      const response = await axiosAPI.get("/api/attendance/get-users");
      setUsers(response.data.results);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getTableUsers = async () => {
    try {
      const response = await axiosAPI.get(
        `/api/attendance/get-user-from-attendance?page=${page}`
      );
      setTableUser(response.data.result);
      setAttendanceData(response.data.result);
      setTotalPages(response?.data?.totalPages);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(()=>{
    getTableUsers()
  },[page])

  console.log("users", tableUser);

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files[0], // single image file
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = new FormData();

      // console.log("user_id", formData.user_id);
      // console.log("punch_in_pic_url", formData.punch_in_pic_url);
      // console.log("punch_out_pic_url", formData.punch_out_pic_url);
      // console.log("punch_in_latitude", formData.punch_in_latitude);
      // console.log("punch_in_long", formData.punch_in_long);
      // console.log("punch_out_latitude", formData.punch_out_latitude);
      // console.log("punch_out_long", formData.punch_out_long);
      // console.log("punch_in", formData.punch_in); // Optional: include punch_in date
      // console.log("punch_out", formData.punch_out); // punch_out date

      // Append all form fields
      payload.append("user_id", formData.user_id);
      payload.append("punch_in_pic", formData.punch_in_pic_url);
      payload.append("punch_out_pic", formData.punch_out_pic_url);
      payload.append("punch_in_lat", formData.punch_in_latitude);
      payload.append("punch_in_long", formData.punch_in_long);
      payload.append("punch_out_lat", formData.punch_out_latitude);
      payload.append("punch_out_long", formData.punch_out_long);
      payload.append("punch_in", formData.punch_in); // Optional: include punch_in date
      payload.append("punch_out", formData.punch_out); // punch_out date

      // console.log("Payload ", payload)
      for (let [key, value] of payload.entries()) {
        console.log(`${key}:`, value);
      }

      // return;

      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/attendance/update/${currentUserId}`,
          payload,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        window.notifyMessage(
          "Success",
          "Attendance updated successfully",
          "success"
        );
      } else {
        response = await axiosAPI.post(
          "/api/attendance/mark-attendance",
          payload,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        window.notifyMessage(
          "Success",
          "Attendance added successfully",
          "success"
        );
      }

      // After success
      hideModal("newUserModal");
      getTableUsers();
      removeFormData();
      setIsEditMode(false);
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // const handleMarkAttendance = async () => {
  //   // if (!userId) {
  //   //   setMessage("Please select your name before marking attendance.");
  //   //   return;
  //   // }

  //   try {
  //     // const res = await axios.post("http://your-backend-url.com/api/mark-attendance", { userId });
  //     const res = await axiosAPI.post("/api/attendance/mark-attendance");
  //     if (res.data.success) {
  //       setMessage("Attendance marked successfully!");
  //     } else {
  //       setMessage("Failed to mark attendance.");
  //     }
  //   } catch (error) {
  //     console.error("Error marking attendance:", error);
  //     setMessage("Server error. Try again later.");
  //   }
  // }

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);

    // Find the notification with this ID and populate the form
    const selectedNotification = notification.find((notif) => notif.id === id);
    if (selectedNotification) {
      setFormData({
        title: selectedNotification.notification_title,
        message: selectedNotification.notification_message,
      });
    }

    const modal = new window.bootstrap.Modal(
      document.getElementById("newUserModal")
    );
    modal.show();
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(
        `/api/attendance/delete-user/${id}`
      );
      window.notifyMessage("Success", "Deleted successfully", "success");
      getTableUsers();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newUserModal");
  };

  function formatDateTime(input) {
    console.log("Input is ", input);
    if (!input) return { date: "N/A", time: "N/A" };

    // If input is like "09-05-2025 15:45", convert to ISO
    let isoInput = input;

    if (!input.includes("T") && input.includes("-")) {
      const [datePart, timePart] = input.split(" ");
      const [day, month, year] = datePart.split("-");
      isoInput = `${year}-${month}-${day}T${timePart || "00:00"}`;
    }

    const dateObj = new Date(isoInput);

    if (isNaN(dateObj)) {
      return { date: "Invalid Date", time: "Invalid Time" };
    }

    const formattedDate = dateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = dateObj.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return { date: formattedDate, time: formattedTime }; // ✅ Corrected line
  }

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Attendance
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Attendance" : "Add Attendance"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Title (Input Field) */}
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="user_id" className="form-label">
                          Select User
                        </label>
                        <select
                          className="form-control"
                          id="user_id"
                          name="user_id"
                          value={formData.user_id}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select a User</option>
                          {users.map((user) => (
                            <option key={user.id} value={user.id}>
                              {user.full_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      {/* Punch In Image */}
                      <div className="mb-3">
                        <label
                          htmlFor="punch_in_pic_url"
                          className="form-label"
                        >
                          Punch In Image
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="punch_in_pic_url"
                          name="punch_in_pic_url"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Punch In</label>
                        <input
                          type="date"
                          className="form-control"
                          name="punch_in"
                          value={formData.punch_in}
                          onChange={handleChange}
                          placeholder="Enter punch out"
                        />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Punch In (Date & Time)
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="punch_in"
                          value={formData.punch_in}
                          onChange={handleChange}
                          placeholder="Enter punch in datetime"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      {/* Punch In Latitude & Longitude */}
                      <div className="mb-3">
                        <label className="form-label">Punch In Lat</label>
                        <input
                          type="text"
                          className="form-control"
                          name="punch_in_latitude"
                          value={formData.punch_in_latitude}
                          onChange={handleChange}
                          placeholder="Enter punch in latitude"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Punch In Long</label>
                        <input
                          type="text"
                          className="form-control"
                          name="punch_in_long"
                          value={formData.punch_in_long}
                          onChange={handleChange}
                          placeholder="Enter punch in Longitude"
                        />
                      </div>
                    </div>

                    <div>
                      <hr />
                    </div>

                    <div className="col-md-6">
                      {/* Punch Out Image */}
                      <div className="mb-3">
                        <label
                          htmlFor="punch_out_pic_url"
                          className="form-label"
                        >
                          Punch Out Image
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="punch_out_pic_url"
                          name="punch_out_pic_url"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/* Punch Out Latitude & Longitude */}
                      <div className="mb-3">
                        <label className="form-label">
                          Punch Out (Date & Time)
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="punch_out"
                          value={formData.punch_out}
                          onChange={handleChange}
                          placeholder="Enter punch out datetime"
                        />
                      </div>
                    </div>
                    {/* Punch Out Latitude & Longitude */}
                    <div className="mb-3">
                      <label className="form-label">Punch Out Lat</label>
                      <input
                        type="text"
                        className="form-control"
                        name="punch_out_latitude"
                        value={formData.punch_out_latitude}
                        onChange={handleChange}
                        placeholder="Enter puch out latitude"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Punch Out Long</label>
                      <input
                        type="text"
                        className="form-control"
                        name="punch_out_long"
                        value={formData.punch_out_long}
                        onChange={handleChange}
                        placeholder="Enter punch out Longitude"
                      />
                    </div>

                    {/* <button
                    className="btn btn-round btn-sm btn-primary"
                    // onClick={handleMarkAttendance}
                  >
                    Mark as Attendance
                  </button>

                  {message && <p className="mt-2">{message}</p>} */}

                    <div>
                      <button
                        type="submit"
                        className="btn btn-primary btn-round btn-sm"
                      >
                        {isEditMode ? "Update Attendance" : "Add Attendance"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Notification Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">
                  {/* Attendance ( {tableUser.length} || {filteredData?.length}) */}
                  Attendance ( {tableUser.length})
                </h4>
                <div className="mb-3">
                  <label className="form-label">Filter By</label>
                  <select
                    className="form-select"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="today">Today</option>
                    <option value="weekly">This Week</option>
                    <option value="monthly">This Month</option>
                  </select>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        {/* <th>Description</th> */}
                        <th>Punch in</th>
                        <th>punch_in_pic</th>
                        <th>punch_in_lat</th>
                        <th>punch_in_long</th>
                        <th>Punch out</th>
                        <th>Punch out pic</th>
                        <th>Punch out Lat</th>
                        <th>Punch out long</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : // tableUser.map((user) => {
                      //   const dateObj = new Date(user.date_and_time);

                      //   // Format date: DD MMM YYYY (e.g., 09 May 2025)
                      //   const formattedDate = dateObj.toLocaleDateString(
                      //     "en-GB",
                      //     {
                      //       day: "2-digit",
                      //       month: "short",
                      //       year: "numeric",
                      //     }
                      //   );

                      //   // Format time: HH:MM AM/PM (e.g., 03:45 PM)
                      //   const formattedTime = dateObj.toLocaleTimeString(
                      //     "en-US",
                      //     {
                      //       hour: "2-digit",
                      //       minute: "2-digit",
                      //       hour12: true,
                      //     }
                      //   );

                      //   return (
                      //     <tr key={user.attendance_id}>
                      //       <td>{user.full_name}</td>
                      //       {/* <td>{truncatedMessage}</td> */}
                      //       <td>
                      //         {formattedDate} {formattedTime}{" "}
                      //       </td>
                      //       <td>
                      //         <button
                      //           className="btn btn-icon btn-round btn-dark btn-sm me-2"
                      //           onClick={() => openEditModal(user.id)}
                      //         >
                      //           <i className="fas fa-edit"></i>
                      //         </button>
                      //         <button
                      //           className="btn btn-icon btn-round btn-danger btn-sm me-2"
                      //           onClick={() =>
                      //             handleDelete(user.attendance_id)
                      //           }
                      //         >
                      //           <i className="fas fa-trash"></i>
                      //         </button>
                      //       </td>
                      //     </tr>
                      //   );
                      // })

                      Array.isArray(filteredData) && filteredData.length > 0 ? (
                        filteredData.map((user) => {
                          // const dateObj = new Date(user.punch_in);

                          // Format date: DD MMM YYYY (e.g., 09 May 2025)
                          // const dateObj = user.punch_in
                          //   ? new Date(user.punch_in)
                          //   : null;

                          // const formattedDate =
                          //   dateObj && !isNaN(dateObj)
                          //     ? dateObj.toLocaleDateString("en-GB", {
                          //         day: "2-digit",
                          //         month: "short",
                          //         year: "numeric",
                          //       })
                          //     : "Invalid Date";

                          // const formattedTime =
                          //   dateObj && !isNaN(dateObj)
                          //     ? dateObj.toLocaleTimeString("en-US", {
                          //         hour: "2-digit",
                          //         minute: "2-digit",
                          //         hour12: true,
                          //       })
                          //     : "Invalid Time";
                          const { date, time } = formatDateTime(user.punch_in);
                          const { date: punch_out_date, time: punch_out_time } =
                            formatDateTime(user.punch_out);
                          // const { date, time } = formatDateTime(user.punch_in);
                          // console.log(punch_out_date,punch_out_time)

                          return (
                            <tr key={user.attendance_id}>
                              <td>{user.full_name}</td>
                              <td>
                                {date} {time}
                              </td>
                              <td>
                                <a
                                  href={user.punch_in_pic_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i
                                    className="fas fa-image"
                                    style={{ fontSize: "24px", color: "blue" }}
                                  ></i>
                                </a>
                              </td>

                              <td>{user.punch_in_lat}</td>
                              <td>{user.punch_in_long}</td>
                              <td>
                                {punch_out_date} {punch_out_time}
                              </td>
                              <td>
                                <a
                                  href={user.punch_out_pic_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i
                                    className="fas fa-image"
                                    style={{ fontSize: "24px", color: "blue" }}
                                  ></i>
                                </a>
                              </td>
                              <td>{user.punch_in_long}</td>
                              <td>{user.punch_in_long}</td>
                              {/* <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(user.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() =>
                                    handleDelete(user.attendance_id)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="3" style={{ textAlign: "center" }}>
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Attendance;
